import { render, staticRenderFns } from "./licenseInfo.vue?vue&type=template&id=041f5f3e&scoped=true&"
import script from "./licenseInfo.vue?vue&type=script&lang=js&"
export * from "./licenseInfo.vue?vue&type=script&lang=js&"
import style0 from "./licenseInfo.vue?vue&type=style&index=0&id=041f5f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041f5f3e",
  null
  
)

export default component.exports